export const isMobile = window.innerWidth < 980;

export const storageKey = 'activity_THSRoptions';

/* *
 *  選擇方案頁 Calendar 共用多語系資料
 *  THSR -> CalendarPC&M (CyRcnn)
 *  GDS/NormalTHSR -> MiniCalendar
 *  GDS/Normal -> Calendar
 * */
export const calendarLoc = {
    // 香港與台灣使用相同語系資料
    'zh-tw': {
        weekdays: ['日', '一', '二', '三', '四', '五', '六'],
        weekdaysForCyRcnn: {
            sun: '日',
            mon: '一',
            tue: '二',
            wed: '三',
            thu: '四',
            fri: '五',
            sat: '六'
        },
        // CyRcnn & MiniCalendar 使用，Calendar要先處理後(移除第一項的空值)再使用
        months: ['', '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
    },
    'en-us': {
        weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        weekdaysForCyRcnn: {
            sun: 'Sun',
            mon: 'Mon',
            tue: 'Tue',
            wed: 'Wed',
            thu: 'Thu',
            fri: 'Fri',
            sat: 'Sat'
        },
        months: ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
    },
    'ja-jp': {
        weekdays: ['日', '月', '火', '水', '木', '金', '土'],
        weekdaysForCyRcnn: {
            sun: '日',
            mon: '月',
            tue: '火',
            wed: '水',
            thu: '木',
            fri: '金',
            sat: '土'
        },
        months: ['', '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
    },
    'th-th': {
        weekdays: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
        weekdaysForCyRcnn: {
            sun: 'อา',
            mon: 'จ',
            tue: 'อ',
            wed: 'พ',
            thu: 'พฤ',
            fri: 'ศ',
            sat: 'ส'
        },
        months: ['', 'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม']
    },
    'zh-cn': {
        weekdays: ['日', '一', '二', '三', '四', '五', '六'],
        weekdaysForCyRcnn: {
            sun: '日',
            mon: '一',
            tue: '二',
            wed: '三',
            thu: '四',
            fri: '五',
            sat: '六'
        },
        months: ['', '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
    },
    'ko-kr': {
        weekdays: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
        weekdaysForCyRcnn: {
            sun: '일요일',
            mon: '월요일',
            tue: '화요일',
            wed: '수요일',
            thu: '목요일',
            fri: '금요일',
            sat: '토요일'
        },
        months: ['', '일월', '이월', '삼월', '사월', '오월', '유월', '칠월', '팔월', '구월', '시월', '십일월', '십이월']
    },
};

// 艙等資料
export const ClassData = {
    // 香港與台灣使用相同語系資料
    'zh-tw': [
        {
            text: '標準車廂',
            value: 'Y',
        },
        {
            text: '商務車廂',
            value: 'J',
        },
    ],
    'en-us': [
        {
            text: 'Standard Car',
            value: 'Y',
        },
        {
            text: 'Business Car',
            value: 'J',
        }
    ],
    'ja-jp': [
        {
            text: '標準車両',
            value: 'Y',
        },
        {
            text: 'ビジネス車両',
            value: 'J',
        }
    ],
    'th-th': [
        {
            text: 'โกดังมาตรฐาน',
            value: 'Y',
        },
        {
            text: 'โกดังธุรกิจ',
            value: 'J',
        }
    ],
    'zh-cn': [
        {
            text: '标准车厢',
            value: 'Y',
        },
        {
            text: '商务车厢',
            value: 'J',
        }
    ],
    'ko-kr': [
        {
            text: '일반실',
            value: 'Y',
        },
        {
            text: '특실',
            value: 'J',
        }
    ]
};